/* eslint-env browser, es6 */
import { MIN_WORD_LENGTH } from "./constants";
import { WORDS_SET } from "./words";

const CSS_TIME_REGEX = /^([0-9.]+)s$/;

export function cssTimeToMillis(cssTime: string): number {
  const match = CSS_TIME_REGEX.exec(cssTime);
  if (!match) {
    throw new Error(`could not parse CSS time: ${cssTime}`);
  }

  return parseFloat(match[1]) * 1000;
}

export function getCssVariable(name: string): string {
  return getComputedStyle(document.body).getPropertyValue(name);
}

export function isWordValid(word: string): boolean {
  return word.length >= MIN_WORD_LENGTH && WORDS_SET.has(word);
}

export function focusAndScrollInput() {
  const input = <HTMLInputElement>document.querySelector(".word-input");
  input.focus();

  setTimeout(() => {
    // The main point of scrolling is to bring the input and board into view on
    // mobile after the keyboard appears. Scroll after focusing because
    // focusing is what causes the keyboard to appear in the first place.
    const clientRect = input.getBoundingClientRect();
    const top = clientRect.y + window.scrollY;
    window.scrollTo({ left: 0, top, behavior: "smooth" });
  }, 200);
}

export function plural(n: number, word: string): string {
  return n === 1 ? `${n} ${word}` : `${n} ${word}s`;
}
